import { isEmpty } from 'lodash';
import { node } from 'prop-types';
import { createContext, useContext, useEffect } from 'react';

import { Banner, SanitizedHtml } from 'components';
import { useFetch, useUser } from 'hooks';
import { appService } from 'services';

export const AlertBannerContext = createContext();

export const AlertBannerContextProvider = ({ children }) => {
  const { isLoggedIn } = useUser();

  const {
    call: alertBannerCall,
    data: alertBanner,
    setData: setAlertBanner,
    loading: alertBannerLoading
  } = useFetch({ filterUserCompany: true, withSetState: false });

  useEffect(() => {
    isLoggedIn && getAlertBanners();
  }, [isLoggedIn]);

  const getAlertBanners = async () => {
    const { data } =
      (await alertBannerCall({
        service: appService.getStrapiServiceName(),
        path: '/api/alert-banners',
        method: 'get',
        query: {
          filters: {
            end_date: {
              $gt: new Date()
            },
            start_date: {
              $lt: new Date()
            }
          }
        }
      })) || {};

    // Only show the first alert banner to prevent layout issues
    if (!isEmpty(data?.body?.data)) {
      setAlertBanner(data.body.data[0]);
    }
  };

  return (
    <AlertBannerContext.Provider value={{ alertBanner, setAlertBanner, alertBannerLoading }}>
      {children}
    </AlertBannerContext.Provider>
  );
};

const AlertBanner = () => {
  const { isLoggedIn } = useUser();
  const { alertBanner, setAlertBanner, alertBannerLoading } = useContext(AlertBannerContext);

  return (
    <>
      {isLoggedIn && !alertBannerLoading && !isEmpty(alertBanner) && (
        <Banner
          type={alertBanner.alertBannerType.name}
          cta={alertBanner.cta?.[0]}
          image={alertBanner.image}
          dataTestId="appAlertBanner"
          onDismiss={() => setAlertBanner(null)}
          className="alert-banner relative z-2 w-full"
        >
          <SanitizedHtml content={alertBanner.text} className="truncate-line five-lines lg:three-lines" />
        </Banner>
      )}
    </>
  );
};

AlertBannerContextProvider.propTypes = {
  children: node.isRequired
};

export default AlertBanner;
